import * as React from 'react';
import { Alert } from '@nackle/paper';
// components
import VersionsNav from 'shared/versions-nav';
import VersionList from './list';
// config
import config from 'app/config';

export default class VersionsWrapper extends React.Component {
    static defaultProps = {
        lists: []
    };
    constructor( props ) {
        super( props );
        props.getSolutions();
    }
    // componentDidMount() {
    //     this.props.getSolutions();
    // }
    componentDidUpdate( prevProps ) {
        if ( prevProps.companyId !== this.props.companyId ) {
            this.props.getSolutions();
        }
    }
    componentWillUnmount() {
        this.props.clearVersions();
    }
    render() {
        const { path, companyId, listPrivacyVersions, lists } = this.props;
        return (
            <div>
                <VersionsNav path={ path } companyId={ companyId } />
                { listPrivacyVersions ? (
                    lists.map( versions => (
                        <div key={ `version-list-${ versions.solutionId }` }>
                            <VersionList { ...versions } companyId={ companyId } />
                        </div>
                    ) )
                ) : (
                    <Alert message="Access Denied." type="warning" showIcon />
                ) }
                { !lists.length && listPrivacyVersions && (
                    <Alert
                        message={
                            <span>
                                No solutions created yet for this company. Solution set-up is
                                required to
                                <span> </span>
                                use Privacy Studio. Please visit
                                <span> </span>
                                <a
                                    href={ `https://${ config.envPrefix }solutions-studio.biw.cloud/${ companyId }` }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Solutions Studio
                                </a>
                                <span> </span>
                                to set up a solution.`
                            </span>
                        }
                        type="warning"
                        showIcon
                    />
                ) }
            </div>
        );
    }
}
